/*
  Busca preditiva da marca — paridade com o Hydrogen.
  <sv-search> lê data-groups (ex.: "product,collection") para escolher os tipos
  pedidos ao Shopify e a ordem de renderização. Debounce 200ms, aborta a
  requisição em voo, abre no foco/digitação, fecha no clique-fora + Escape.
  Navegação "ver todos" / lupa / Enter = submit nativo do form → /search?q=.
*/
(function () {
  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var LABELS = { product: 'Produtos', collection: 'Coleções', page: 'Páginas', article: 'Artigos' };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Miniatura no tamanho do thumb (44px @2x) sem baixar full-res.
  function sized(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=88';
  }

  function imgUrl(o) {
    if (!o) return '';
    if (o.featured_image && o.featured_image.url) return o.featured_image.url;
    if (typeof o.featured_image === 'string') return o.featured_image;
    if (typeof o.image === 'string') return o.image;
    if (o.image && o.image.url) return o.image.url;
    return '';
  }

  // suggest.json devolve preço já em reais (string, ex. "34.50"). NÃO dividir por 100.
  function priceHtml(p) {
    var n = Number(p && p.price);
    if (!isFinite(n) || n <= 0) return '';
    return '<span class="sv-psearch__price">' + esc(BRL.format(n)) + '</span>';
  }

  function itemHtml(o, withPrice) {
    var url = imgUrl(o);
    var thumb = url
      ? '<span class="sv-psearch__thumb"><img src="' + esc(sized(url)) + '" alt="" width="44" height="44" loading="lazy"></span>'
      : '';
    var price = withPrice ? priceHtml(o) : '';
    return '<li><a class="sv-psearch__item" href="' + esc(o.url) + '">' +
      thumb +
      '<span class="sv-psearch__meta">' +
      '<span class="sv-psearch__title">' + esc(o.title) + '</span>' +
      price +
      '</span></a></li>';
  }

  function groupHtml(type, list) {
    if (!list || !list.length) return '';
    var withPrice = type === 'product';
    var items = list.map(function (o) { return itemHtml(o, withPrice); }).join('');
    return '<div class="sv-psearch__group">' +
      '<h5 class="sv-psearch__gtitle">' + LABELS[type] + '</h5>' +
      '<ul class="sv-psearch__list">' + items + '</ul></div>';
  }

  var TAGMAP = { product: 'products', collection: 'collections', page: 'pages', article: 'articles' };

  var SvSearch = function () {};

  function render(el, results, term, groups) {
    var box = el._results;
    var html = '';
    var total = 0;
    for (var i = 0; i < groups.length; i++) {
      var key = TAGMAP[groups[i]];
      var list = (results && results[key]) || [];
      total += list.length;
      html += groupHtml(groups[i], list);
    }
    if (total > 0) {
      html += '<button type="submit" class="sv-psearch__all">Ver todos os resultados →</button>';
    } else if (term) {
      html = '<p class="sv-psearch__empty">Nada encontrado para <q>' + esc(term) + '</q>.</p>';
    }
    box.innerHTML = html;
    open(el, term.length > 0);
  }

  function open(el, show) {
    el._panel.hidden = !show;
    el.classList.toggle('is-open', !!show);
  }

  function fetchResults(el, term, groups) {
    if (el._ctrl) el._ctrl.abort();
    el._ctrl = new AbortController();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=' + groups.join(',') +
      '&resources[limit]=5&resources[options][unavailable_products]=last';
    fetch(url, { signal: el._ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var results = data && data.resources && data.resources.results;
        render(el, results || {}, term, groups);
      })
      .catch(function (e) { if (e.name !== 'AbortError') { /* ignore */ } });
  }

  function upgrade(el) {
    if (el._sv) return;
    el._sv = true;
    var groups = (el.getAttribute('data-groups') || 'product,collection').split(',');
    el._mobile = el.classList.contains('sv-psearch--mobile');
    var input = el.querySelector('[data-sv-search-input]');
    el._panel = el.querySelector('[data-sv-search-panel]');
    el._results = el.querySelector('[data-sv-search-results]');
    var timer;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (!term) { open(el, false); el._results.innerHTML = ''; if (el._ctrl) el._ctrl.abort(); return; }
      // "Buscando…" só no aside mobile; no dropdown desktop o painel só abre com resultado
      if (el._mobile) {
        el._results.innerHTML = '<p class="sv-psearch__loading">Buscando…</p>';
        open(el, true);
      }
      timer = setTimeout(function () { fetchResults(el, term, groups); }, 200);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() && el._results.innerHTML) open(el, true);
    });

    document.addEventListener('mousedown', function (e) {
      if (!el.contains(e.target)) open(el, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { open(el, false); input.blur(); }
    });
  }

  function boot() {
    document.querySelectorAll('sv-search').forEach(upgrade);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
